// extracted by mini-css-extract-plugin
module.exports = {"boldText":"M_gv-QfhsySA-eSmOJFO","mainTable":"_36NeTygR3egCcN8t5De2_e","detailsTable":"_1L5CREhfdntUz1BPCFbIw4"};